import React, { useState } from "react";
import styled from "styled-components";
import { Button, Checkbox } from "@mui/material";

import { A, ContentHolder, H2, H3, Loading } from "commons";
import { useComponentState } from "commons/src/helpers/CustomHooks";

import { acceptTerms, logout } from "../../components/DataOperations";
import { TermsAndConditionsLink } from "../Login/PlatformLinks";
import { ERROR as ERROR_SEVERITY } from "../../helpers/ErrorHelpers";
import { Message } from "../../components/Message";

export function Terms() {
    const [areTermsAccepted, setAreTermsAccepted] = useState(false);
    const [currentState, changeStateTo, { LOADING, ERROR }] = useComponentState();

    const handleTermsChange = () => setAreTermsAccepted(v => !v);

    const submit = async e => {
        e.preventDefault();
        if (areTermsAccepted) {
            try {
                changeStateTo(LOADING);
                await acceptTerms();
            } catch {
                changeStateTo(ERROR);
            }
        }
    };

    const handleLogout = () => logout();

    return (
        <ContentHolder>
            {currentState === ERROR && (
                <Message
                    severity={ERROR_SEVERITY}
                    text="There was a problem with trying to accept terms. Please try again or contact support"
                />
            )}

            <H2 textAlign="center">New terms and conditions</H2>
            <Form onSubmit={submit}>
                <p>
                    We have updated our Terms and Conditions. Please read them carefully and agree
                    to continue
                </p>
                <Controls>
                    <StyledLoading displayWhen={currentState !== LOADING} size={25}>
                        <CheckboxContainer>
                            <Checkbox
                                id="terms"
                                color="primary"
                                onChange={handleTermsChange}
                                checked={areTermsAccepted}
                            />
                            <CheckboxLabel htmlFor="terms">
                                I have read and agreed to the{" "}
                                <A target="_blank" href={TermsAndConditionsLink}>
                                    Terms and Conditions
                                </A>{" "}
                                of using this service
                            </CheckboxLabel>
                        </CheckboxContainer>
                        <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            size="large"
                            disabled={!areTermsAccepted}
                        >
                            Submit
                        </Button>
                    </StyledLoading>
                </Controls>
                <Button color="primary" onClick={handleLogout}>
                    <BackButtonText>Back to login?</BackButtonText>
                </Button>
            </Form>
        </ContentHolder>
    );
}

const Controls = styled.div`
    margin-bottom: 1rem;
`;

const CheckboxContainer = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
`;

const BackButtonText = styled(H3)`
    font-size: 1.125rem;
    margin: 0;
`;

const StyledLoading = styled(Loading)`
    margin: 0.5rem;
`;

const Form = styled.form`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
`;

const CheckboxLabel = styled.label`
    font-size: 1rem;
`;
